export const transSizeToRem = (size) => {
    if (typeof size === "string" && size.match("rem")) {
        return size;
    }
    return `${size}rem`;
};
export function getCellWidthByGridM({ contentWidth = "100%", gridCol, gridGap, }) {
    return `calc((${contentWidth} - ${gridGap * (gridCol - 1)}rem) / ${gridCol})`;
}
export const px2rem = (pxValue, defaultValue = "initial") => {
    if (typeof pxValue !== "undefined") {
        return `${Number((pxValue / 16).toFixed(4))}rem`;
    }
    return defaultValue;
};
